<div class="collab-panel">
  <p class="collab-loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i> Carregando comentários...
  </p>

  <div class="collab-thread" *ngIf="!loading">
    <div
      class="collab-bubble"
      *ngFor="let c of comentarios"
      [class.collab-bubble--cliente]="isCliente(c)"
      [class.collab-bubble--sistema]="isSistema(c)"
      [class.collab-bubble--interno]="c.interno">
      <div class="collab-bubble__head">
        <strong>{{ c.autor }}</strong>
        <span class="collab-chip">{{ origemLabel(c) }}</span>
        <span class="collab-chip collab-chip--interno" *ngIf="c.interno">
          <i class="fas fa-lock"></i> Interno
        </span>
        <span class="collab-when">{{ c.criadoEm | brDate:'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <span class="collab-anchor" *ngIf="c.linhaId">
        Sobre {{ c.linhaTipo === 'item' ? 'a peça' : 'o serviço' }} #{{ c.linhaId }}
      </span>

      <p class="collab-bubble__text">{{ c.mensagem }}</p>
    </div>

    <p class="collab-empty" *ngIf="comentarios.length === 0">
      {{ emptyLabel }}
    </p>
  </div>

  <div class="collab-compose">
    <textarea
      class="form-control"
      rows="3"
      placeholder="Escreva um comentário..."
      [(ngModel)]="mensagem"
      [disabled]="sending"></textarea>

    <div class="collab-compose__actions">
      <div class="form-check" *ngIf="allowInternal">
        <input
          class="form-check-input"
          type="checkbox"
          id="comentarioInternoCollab"
          [(ngModel)]="interno"
          [disabled]="sending" />
        <label class="form-check-label" for="comentarioInternoCollab">
          <i class="fas fa-lock"></i>
          Comentário interno (o cliente não verá)
        </label>
      </div>

      <button
        type="button"
        class="btn btn-primary btn-sm"
        [disabled]="sending || !mensagem.trim()"
        (click)="send()">
        <i class="fas" [class.fa-paper-plane]="!sending" [class.fa-spinner]="sending" [class.fa-spin]="sending"></i>
        {{ sending ? 'Enviando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</div>
